import { Component,Inject, OnInit } from '@angular/core';
// import { MatDialog,MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog, MatDialogConfig, MatDialogRef, } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { ToastrService } from 'ngx-toastr';
import { ShareDialogReferralComponent } from '../share-dialog-referral/share-dialog-referral.component';

@Component({
  selector: 'app-enjoying-app-dialog',
  templateUrl: './enjoying-app-dialog.component.html',
  styleUrls: ['./enjoying-app-dialog.component.css']
})
export class EnjoyingAppDialogComponent implements OnInit {
  user:any;
  referralObj:any;
  textAreaLink:any;
  constructor(
    public dialog: MatDialog, 
    private _inviteService:InviteEarnService,
    private _router:Router,
    private _toastr:ToastrService,
    private _dialogRef: MatDialogRef<EnjoyingAppDialogComponent>
    ) { }

  ngOnInit(): void {
    this.user=this._inviteService.getUserInfo();
    this.getRefCode(this.user.userId,this.user.name);
  }
  getRefCode(userId:any, userName: any){
    this._inviteService.generateReferralCode(userId, userName).subscribe({next:(data)=>{
      console.log({refCode:data});
      this.referralObj=data;
      this.textAreaLink=this.referralObj.deepLink;
      this.referralObj.deepLink="Hi! Here’s a fun learning App with live classes, videos, flashcards, mock tests, instant doubt clarification and much more. Join me on Infinity Learn and get 100 Infinity Coins on sign up. \n"+this.referralObj.deepLink;
      this._inviteService.setRefToLocalStorage(this.referralObj?.userReferralId,this.referralObj?.deepLink,this.textAreaLink);
    },error:(err)=>{}})
  }

  copyRefCode(){
    console.log(this.referralObj.deepLink);
    this._toastr.success("Text Copied!")
    navigator.clipboard.writeText(this.textAreaLink);
  }

  navigateMyReferralDashboard(){
    this._router.navigateByUrl('/dashboard/referral/');
  }

   //Dialog for enjoying app
   shareSocialdialog() {
    this._dialogRef.close({ data: true });
    const config: MatDialogConfig = {      
      panelClass: ['REF-share-dialog'],
      width:'380',           
      data: {
        shareUrl:this.referralObj.deepLink,
        userRferralId:this.referralObj.userReferralId,
        textUrl:this.textAreaLink
      },
    };
    const dialogRef = this.dialog.open(ShareDialogReferralComponent, config);
   
  }
  // close() {
  //   this.dialogRef.close();
  // }
  sendModeOfShare(modeOfShare:any){
    console.log(modeOfShare);
    this._dialogRef.close({ data: true });
    this._inviteService.sendModeOfShareDetails(modeOfShare,this.referralObj?.userReferralId).subscribe((res)=>{console.log(res);
    })
  }
  sendNdNavigate(modeOfShare){
    let currentWindow=localStorage.getItem('currentPage');
    let refURL="referral"
    this.sendModeOfShare(modeOfShare);
    if(currentWindow!=refURL){
      this.navigateMyReferralDashboard();
    }
  }
}
